// Vite-compatible image imports
// Using import.meta.glob for dynamic imports in Vite

// Import all images from category folder
const categoryImagesPng = import.meta.glob('../images/category/*.png', { eager: true });
const categoryImagesJpg = import.meta.glob('../images/category/*.jpg', { eager: true });
const categoryImagesJpeg = import.meta.glob('../images/category/*.jpeg', { eager: true });
const categoryImagesSvg = import.meta.glob('../images/category/*.svg', { eager: true });
const categoryImages = { ...categoryImagesPng, ...categoryImagesJpg, ...categoryImagesJpeg, ...categoryImagesSvg };

// Import all images from items folder  
const itemImagesPng = import.meta.glob('../images/items/*.png', { eager: true });
const itemImagesJpg = import.meta.glob('../images/items/*.jpg', { eager: true });
const itemImagesJpeg = import.meta.glob('../images/items/*.jpeg', { eager: true });
const itemImagesSvg = import.meta.glob('../images/items/*.svg', { eager: true });
const itemImages = { ...itemImagesPng, ...itemImagesJpg, ...itemImagesJpeg, ...itemImagesSvg };

// Import all images from kits folder
const kitImagesPng = import.meta.glob('../images/kits/*.png', { eager: true });
const kitImagesJpg = import.meta.glob('../images/kits/*.jpg', { eager: true });
const kitImagesJpeg = import.meta.glob('../images/kits/*.jpeg', { eager: true });
const kitImagesSvg = import.meta.glob('../images/kits/*.svg', { eager: true });
const kitImages = { ...kitImagesPng, ...kitImagesJpg, ...kitImagesJpeg, ...kitImagesSvg };

// Helper function to process the imported images
const processImages = (images: Record<string, any>) => {
  const processedImages: Record<string, string> = {};
  
  Object.entries(images).forEach(([path, module]) => {
    // Extract filename from path (remove the '../images/...' prefix)
    // Handle both forward slashes and backslashes (Windows paths)
    const filename = path.split(/[/\\]/).pop() || '';
    processedImages[filename] = (module as any).default || module;
  });
  
  return processedImages;
};

// Process the imported images
const processedCategoryImages = processImages(categoryImages);
const processedItemImages = processImages(itemImages);
const processedKitImages = processImages(kitImages);

export { 
  processedCategoryImages as categoryImages, 
  processedItemImages as itemImages, 
  processedKitImages as kitImages 
};
